module.exports = __webpack_public_path__ + "img/back.754bc3d8.png";